<template>
  <div class="modal-subway">
    <div v-if="subwayStations">
      <SubwayStationsItem
        :stations="subwayStations"
        :lines="subwayLinesMap"
        :shown-lines="visibleLines"
      />
    </div>
    <div v-else class="loader-wrapper">
      <vue-loaders name="ball-grid-pulse" :color="primaryColor" />
    </div>
    <ModalButtons
      :reset="resetSubway"
      :select="chooseSubway"
      class="buttons-wrapper"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import constants from '@/dependencies/constants'
import ModalButtons from '@/components/Common/FilterModalButtons'
import SubwayStationsItem from '~/components/Dropdowns/Parts/SubwayStationsItem'

export default {
  name: 'Subway',
  components: {
    SubwayStationsItem,
    ModalButtons
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      subwayLines: 'search/getSubwayLines',
      subwayLinesMap: 'search/getSubwayLinesMap',
      subwayStations: 'search/getSubwayStations'
    }),
    visibleLines() {
      return Object.keys(this.subwayLinesMap).sort((a, b) => b - a)
    },
    primaryColor() {
      return constants.COLORS.PRIMARY_COLOR
    }
  },
  methods: {
    ...mapActions({
      setSubway: 'search/SET_SUBWAY'
    }),
    chooseSubway() {
      this.$emit('clicked')
      this.$bus.$emit('chooseSubway')
    },
    resetSubway() {
      this.$bus.$emit('resetSubway')
    }
  }
}
</script>

<style scoped lang="scss">
.modal-subway {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 50vh;
  padding: 25px 3px 0 25px;
}
.buttons-wrapper {
  position: sticky;
  bottom: 0;
  padding: 10px 35px 10px 10px;
  background-color: white;
  z-index: 2;

  button {
    font-weight: bold;
  }
}
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 70vh;
}
</style>
